// One filter's trigger and its non-modal panel (Buttons Menu, mode="panel"). The trigger shows the
// column label, then the committed summary while the filter is active, in the selected control treatment.

import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import { Menu } from '@CommonComponents/buttons'
import { useTable } from '../context'
import { filterSummary } from './drafts'

/** The bar's open-panel reporter: (key, open) => void. Outside a bar it does nothing. */
export const FilterOpenContext = createContext(() => {})

/** The onOpenChange handler for the trigger that owns `key`. */
export const useOpenReporter = key => {
  const reportOpen = useContext(FilterOpenContext)
  return open => reportOpen(key, open)
}

export const triggerClass = active =>
  `me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger${
    active ? ' me-btn-selected' : ''
  }`

export const FilterMenu = ({ column, children }) => {
  const { state } = useTable()
  const onOpenChange = useOpenReporter(column.key)
  const summary = filterSummary(column, state.query.filters[column.key])
  return (
    <Menu
      mode="panel"
      label={`${column.label} filter`}
      valueLabel={summary ? `${column.label}: ${summary}` : column.label}
      className={triggerClass(Boolean(summary))}
      onOpenChange={onOpenChange}
    >
      <div className="me-table-filter-panel">{children}</div>
    </Menu>
  )
}

FilterMenu.propTypes = {
  column: PropTypes.object.isRequired,
  children: PropTypes.node,
}
